export const LOCAL_STORAGE_CONSTANTS = {
  accessToken: 'MAG:accessToken',
  eventName: 'MAG:localStorageChanged',
  isEmployee: 'MAG:isEmployee',
  refreshToken: 'MAG:refreshToken'
}